export interface GridItemSize {
  width: number
  height: number
}

export const DEFAULT_SHORTCUT_ITEM_SIZE: GridItemSize = {
  width: 3,
  height: 3
}

export const NEED_HELP_SHORTCUT_ITEM_SIZE: GridItemSize = {
  width: 4,
  height: 4
}
